import { Directive, ElementRef   } from '@angular/core';

@Directive({
  selector: '[mandatory]'
})

export class MandatoryDirective {

 constructor(private el: ElementRef) {
    const parent = this.el.nativeElement.parentNode;
    if (parent) {
      const span = document.createElement('span');
      span.innerHTML = ' * '.fontcolor('red');
      parent.appendChild(span);
    }    
  }
}